import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { GlobalShipmentsPage } from '@/components/GlobalShipments/GlobalShipmentsPage'
import { listSearchSchema, withoutListDefaults } from '@/components/common/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the shared list page. */
export const Route = createFileRoute('/_app/operations/global-shipments/')({
  validateSearch: listSearchSchema,
  component: GlobalShipmentsRoute,
})

function GlobalShipmentsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <GlobalShipmentsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
